import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import { Stack, styled, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import approvalImage from '../assets/approvalImage.png';
import kidsSmile from '../assets/KidsClassroomMed.jpg';
import schoolImage from '../assets/school.jpg';
import BookingSummaryGrid from '../components/BasicComponents/BookingSummaryGrid';
import HomePageTopSection from '../components/BasicComponents/HomePageTopSection';
import Loading from '../components/Loading';
import { fetchSchoolBooking } from '../redux/BookingSlice';
import { storeToken } from '../redux/TokenSlice';

const IconImage = styled('img')(({ theme }) => ({
    width: '100px',
    height: 'auto',
    borderRadius: '5%',
    textAlign: 'center',
}));

export const SchoolHome = () => {
    const profile = useSelector(state => state.profile);
    const { booking } = useSelector(state => state.booking);
    const tokenObj = useSelector(state => state.token.token);
    const tokenStatus = useSelector(state => state.token.status);
    const dispatch = useDispatch();

    const [canBook, setCanBook] = useState(false);
    const [cannotViewBooking, setCannotViewBooking] = useState(false);

    const { getAccessTokenSilently } = useAuth0();

    console.log('Profile status on Home Page: ' + JSON.stringify(profile));
    console.log(
        'Profile type for Home Page: ' +
            profile.profile.Data.Items[0].type.value
    );

    useEffect(() => {
        if (tokenStatus === 'succeeded') {
            if (tokenObj.permissions.find(perm => perm === 'create:booking')) {
                setCanBook(true);
            } else if (
                !tokenObj.permissions.find(perm => perm === 'read:booking')
            ) {
                setCannotViewBooking(true);
            }
        }
    }, [tokenStatus, tokenObj]);

    useEffect(() => {
        //Get the latest booking information on the home page
        console.log(JSON.stringify(profile.profile));
        if (profile.profile.Data.Count > 0) {
            if (profile.profile.Data.Items[0].type === 'School') {
                async function dispatchBookingFromStore() {
                    const token = await getAccessTokenSilently({
                        scope: process.env.REACT_APP_scope,
                        ignoreCache:
                            !window.location.href.includes('localhost') &&
                            !window.location.href.includes('app-test'),
                    });
                    dispatch(storeToken(token));
                    dispatch(
                        fetchSchoolBooking({
                            token: token,
                            status1: 'Completed',
                            status2: 'Approved',
                            status3: 'Pending Review',

                            location: 'Home',
                        })
                    );
                }
                dispatchBookingFromStore();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [profile]);

    const AwaitingVerification = () => {
        return (
            <Stack direction="column" sx={{ alignItems: 'center' }}>
                <Typography
                    variant="h6"
                    sx={{ padding: '20px' }}
                    data-cy="awaiting-approval"
                >{`Your School profile is awaiting approval verification`}</Typography>
                <Typography
                    variant="body"
                    sx={{ padding: '20px' }}
                >{`You will receive an email when you are ready to start using the airTeachr platform`}</Typography>
                <IconImage src={approvalImage} sx={{ marginBottom: '20px' }} />
            </Stack>
        );
    };

    return (
        <div>
            <HomePageTopSection
                location="/book-teacher"
                title="Book a teacher"
                buttonTitle="Book a teacher"
                smallImage={schoolImage}
                largeImage={kidsSmile}
                textColor="#FFF"
                verified={canBook}
            />

            {cannotViewBooking ? (
                <AwaitingVerification />
            ) : (
                <BookingSummaryGrid
                    sx={{ paddingBottom: '20px' }}
                    Grid1={{
                        title: 'Upcoming Shifts',
                        subtitle:
                            'When you have shift bookings this section lets you know the most recent ones coming up so you can see them at a glance',
                        type: 'upcoming bookings',
                        status: 'Approved',
                        status2: 'Approved',
                        profileType: 'School',
                    }}
                    Grid2={{
                        title: 'Ratings Required',
                        subtitle:
                            'This section contains a list of bookings that have finished and require your rating and comments',
                        type: 'upcoming bookings',
                        status: 'Completed',
                        status2: 'Completed',
                        status3: 'Pending Review',
                        profileType: 'School',
                        showStatus: true,
                    }}
                    booking={booking.Data}
                />
            )}
        </div>
    );
};

export default withAuthenticationRequired(SchoolHome, {
    onRedirecting: () => <Loading />,
});
